import { UPDATE_CALL_INFORMATION, UPDATE_MUTE_STATUS } from './types';

export function updateCallInformation(call) {
  return {
    type: UPDATE_CALL_INFORMATION,
    call,
  };
}

export function updateMuteStatus(isMuted) {
  return {
    type: UPDATE_MUTE_STATUS,
    isMuted,
  };
}
